module.exports = __webpack_public_path__ + "static/logo-cocowat-a48d8f6dc38c9de32a1121702aace575.png";